import React, { useEffect, useState } from "react";
import MaterialTypeSelector from "../shared/MaterialTypeSelector";
import { InventoryRecord } from "../../types/InventoryItem";

interface FilterBarProps {
    filters: {
        material_type_id: number | null;
        color_code: string | null;
        material_size_id: number | null;
        hideZero: boolean;
        records: InventoryRecord[];
    };
    onFilterChange: (filters: {
        material_type_id: number | null;
        color_code: string | null;
        material_size_id: number | null;
        hideZero: boolean;
        records: InventoryRecord[];
    }) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ filters, onFilterChange }) => {
    const [ localFilters, setLocalFilters ] = useState(filters);

    // Sync local filters with parent-provided filters
    useEffect(() => {
        setLocalFilters(filters);
    }, [ filters ]);

    const handleSelectorChange = (selection: {
        material_type_id: number | null;
        color_code: string | null;
        material_size_id: number | null;
    }) => {
        const updatedFilters = { ...localFilters, ...selection };
        setLocalFilters(updatedFilters);
        onFilterChange(updatedFilters);
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const updatedFilters = { ...localFilters, hideZero: e.target.checked };
        setLocalFilters(updatedFilters);
        onFilterChange(updatedFilters);
    };

    return (
        <div className="rounded-lg space-y-4">
            {/* Material Type Selector */}
            <MaterialTypeSelector required={false} onSelect={handleSelectorChange}/>

            {/* Hide Zero Checkbox */}
            <div className="flex justify-end items-center py-2 px-4">
                <label className="flex items-center gap-4 cursor-pointer text-gray-700 dark:text-gray-200">
                    Hide Items with Quantity is 0
                    <div className="relative inline-flex items-center">
                        <input
                            type="checkbox"
                            checked={localFilters.hideZero}
                            onChange={handleCheckboxChange}
                            className="sr-only peer"
                        />
                        <div
                            className="w-11 h-6 bg-gray-300 dark:bg-gray-600 rounded-full peer peer-checked:bg-blue-600 dark:peer-checked:bg-blue-400 peer-focus:ring-2 peer-focus:ring-blue-500 dark:peer-focus:ring-blue-300 transition-colors duration-200"
                        ></div>
                        <div
                            className="absolute left-1 top-1 w-4 h-4 bg-white dark:bg-gray-300 rounded-full peer-checked:translate-x-5 transition-transform duration-200 shadow"
                        ></div>
                    </div>
                </label>
            </div>
        </div>
    );
};

export default FilterBar;